import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'chassis-form-edit-page',
    templateUrl: './edit.page.html',
    styleUrls: ['./edit.page.scss']
})
export class FormEditPage implements OnInit {

    public entityId = null;
    public formId   = null;

    public constructor(private route: ActivatedRoute) {

    }

    public ngOnInit() {
        this.entityId = this.route.snapshot.params['entity'];
        this.formId   = this.route.snapshot.params['form'];
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/entities/forms/edit/edit.page.ts